// extracted by mini-css-extract-plugin
export default {"wrapper":"TechStack_wrapper__GMCZK","group":"TechStack_group__6bUvM","groupTitle":"TechStack_groupTitle__rwEOr","items":"TechStack_items__-6jXv"};